type Props = {
  dark?: boolean;
  width?: number;
};

const ratio = 150 / 48;
export const Logo = ({ dark = false, width = 150 }: Props) => {
  const color = dark ? "#202239" : "white";
  const height = width / ratio;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 150 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2104_201389)">
        <path d="M25.2406 0H21.7383V19.5537H25.2406V0Z" fill="#EF652B" />
        <path
          d="M25.2406 43.3662H21.7383V46.8687H25.2406V43.3662Z"
          fill="#EF652B"
        />
        <path
          d="M16.0149 40.8984L12.9258 46.2489L15.9589 48.0002L19.048 42.6495L16.0149 40.8984Z"
          fill="#EF652B"
        />
        <path
          d="M12.3008 35.8984L4.63086 40.3267L6.38197 43.3599L14.0519 38.9316L12.3008 35.8984Z"
          fill="#EF652B"
        />
        <path
          d="M11.5807 29.709H0.0527344V33.2113H11.5807V29.709Z"
          fill="#EF652B"
        />
        <path
          d="M1.75117 16.8877L0 19.9208L12.303 27.0239L14.0541 23.9908L1.75117 16.8877Z"
          fill="#EF652B"
        />
        <path
          d="M10.6054 5.65039L7.57227 7.40157L16.0146 22.0239L19.0476 20.2726L10.6054 5.65039Z"
          fill="#EF652B"
        />
        <path
          d="M70.5413 30.4409H60.8203V23.2695H57.9863V40.1442H60.8203V32.9727H70.5413V40.1442H73.3751V23.2695H70.5413V30.4409Z"
          fill={color}
        />
        <path
          d="M85.2667 23.0703C79.6211 23.0703 76.4473 27.0281 76.4473 31.6875C76.4473 36.3471 79.6211 40.3448 85.2667 40.3448C90.9122 40.3448 94.0861 36.387 94.0861 31.6875C94.0861 26.988 90.9122 23.0703 85.2667 23.0703ZM85.2667 37.7751C81.149 37.7751 79.3612 34.9235 79.3612 31.6875C79.3612 28.4516 81.149 25.6421 85.2667 25.6421C89.3843 25.6421 91.1722 28.5138 91.1722 31.6875C91.1722 34.8612 89.3843 37.7751 85.2667 37.7751Z"
          fill={color}
        />
        <path
          d="M128.383 33.2747C128.383 36.7104 126.775 37.7943 123.422 37.7943C120.068 37.7943 118.46 36.7104 118.46 33.2747V23.2715H115.648V33.2747C115.648 38.2763 117.878 40.3461 123.422 40.3461C128.965 40.3461 131.195 38.3384 131.195 33.2747V23.2715H128.383V33.2747Z"
          fill={color}
        />
        <path
          d="M144.636 30.6038L140.861 30.0018C138.751 29.6798 137.405 29.0579 137.405 27.7121C137.405 26.2662 138.811 25.5422 141.684 25.5422C144.918 25.5422 146.204 26.4461 146.204 28.3539V28.5537H149.096V28.3539C149.096 24.9581 146.585 23.0703 141.642 23.0703C137.003 23.0703 134.491 24.6783 134.491 27.812C134.491 30.5037 136.439 31.7897 139.19 32.2317L142.907 32.8535C145.638 33.2955 146.682 33.7575 146.702 35.4054C146.702 37.1133 145.296 37.875 142.182 37.875C138.386 37.875 136.798 36.7913 136.798 34.2794V34.0794H133.887V34.2794C133.887 38.217 136.439 40.347 142.103 40.347C147.366 40.347 149.595 38.8412 149.595 35.2055C149.595 32.2517 147.747 31.0679 144.635 30.6059L144.636 30.6038Z"
          fill={color}
        />
        <path
          d="M112.479 28.4732C112.479 25.0773 110.369 23.2695 106.474 23.2695H97.1523V40.1442H99.984V33.8168H105.972L109.643 40.1442H112.954L109.07 33.4236C111.773 32.5109 112.479 30.1944 112.479 28.4732ZM106.391 31.2648H99.984V25.8213H106.232C108.421 25.8213 109.565 26.5055 109.565 28.4532C109.565 30.7829 108.319 31.2648 106.391 31.2648Z"
          fill={color}
        />
        <path
          d="M46.4592 25.6419C49.9151 25.6419 51.8028 27.7119 51.9827 29.9217V29.9306H54.9165V29.9217C54.5946 26.2661 51.6207 23.0723 46.4392 23.0723C40.6137 23.0723 37.5 26.9901 37.5 31.6697C37.5 36.3491 40.5938 40.3469 46.4193 40.3469C51.6273 40.3469 54.5768 37.1508 54.9122 33.4886H51.9806C51.7851 35.7072 49.9594 37.7772 46.4392 37.7772C42.2617 37.7772 40.4139 34.9655 40.4139 31.7096C40.4139 28.4537 42.2618 25.6419 46.4592 25.6419Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_2104_201389">
          <rect width="149.6" height="48" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};
